module.exports = __webpack_public_path__ + "static/fipcmusicalanimals-6c41b89830a39546ab47bd372649865e.jpeg";